import React, { useEffect, useState } from 'react';
import { useSlate } from 'slate-react';
import Button from '../common/Button';
import Icon from '../common/Icon';
import { activeMark, addMarkData, isBlockActive, isMarkActive, toggleBlock, toggleMark } from '../utils/SlateUtilityFunctions';
import useFormat from '../utils/customHooks/useFormat.js';
import { reducedToolbarGroups } from './toolbarGroups.js';
import ColorPicker from '../Elements/ColorPicker/ColorPicker';
import LinkButton from '../Elements/Link/LinkButton';
import Embed from '../Elements/Embed/Embed';
import TableSelector from '../Elements/Table/TableSelector';
import Id from '../Elements/ID/ID';
import TableContextMenu from '../Elements/TableContextMenu/TableContextMenu';
import styles from './ToolbarSmall.module.scss';

const ToolbarSmall = (props) => {
    const { icon, savingData } = props;
    const editor = useSlate();
    const isTable = useFormat(editor, 'table');
    const [toolbarGroups, setToolbarGroups] = useState(reducedToolbarGroups);

    const BlockButton = ({ format, icon }) => {
        return (
            <Button
                active={isBlockActive(editor, format)}
                format={format}
                onMouseDown={(e) => {
                    e.preventDefault();
                    toggleBlock(editor, format);
                }}
            >
                <Icon icon={icon} height="16px" />
            </Button>
        );
    };
    const MarkButton = ({ format, icon }) => {
        return (
            <Button
                active={isMarkActive(editor, format)}
                format={format}
                onMouseDown={(e) => {
                    e.preventDefault();
                    toggleMark(editor, format);
                }}
            >
                <Icon icon={icon} height="16px" />
            </Button>
        );
    };
    const Dropdown = ({ format, options }) => {
        return (
            <select value={activeMark(editor, format) || '12px'} onChange={(e) => changeMarkData(e, format)} className={styles.Select}>
                {options.map((item, index) => (
                    <option key={index} value={item.value}>
                        {item.text}
                    </option>
                ))}
            </select>
        );
    };
    const changeMarkData = (event, format) => {
        event.preventDefault();
        const value = event.target.value;
        addMarkData(editor, { format, value });
    };

    return (
        <div className={styles.Toolbar}>
            {/* <div className={styles.ToolbarLeft}> */}
            {toolbarGroups.map((group, index) => (
                <span key={index} className={styles.ToolbarGrp}>
                    {group.map((element) => {
                        switch (element.type) {
                            case 'block':
                                return <BlockButton key={element.id} {...element} />;
                            case 'mark':
                                return <MarkButton key={element.id} {...element} />;
                            case 'dropdown':
                                return <Dropdown key={element.id} {...element} />;
                            case 'link':
                                return (
                                    <LinkButton
                                        key={element.id}
                                        active={isBlockActive(editor, 'link')}
                                        editor={editor}
                                        icon={element?.icon}
                                    />
                                );
                            case 'embed':
                                return <Embed key={element.id} format={element.format} editor={editor} icon={element?.icon} />;
                            case 'color-picker':
                                return (
                                    <ColorPicker
                                        key={element.id}
                                        activeMark={activeMark}
                                        format={element.format}
                                        editor={editor}
                                        iconHeight={'14'}
                                    />
                                );
                            case 'table':
                                return <TableSelector key={element.id} editor={editor} icon={element?.icon} />;
                            case 'id':
                                return <Id editor={editor} />;
                            default:
                                return null;
                        }
                    })}
                </span>
            ))}
            {/* </div> */}
        </div>
    );
};

export default ToolbarSmall;
